import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import PageHeader from "@/components/feature/PageHeader";
import StartProjectCTA from "@/components/feature/StartProjectCTA";

const STEPS = [
  { num: "01", title: "Discover", body: "We visit the home, understand how you live, and assess what's structurally and architecturally possible." },
  { num: "02", title: "Design", body: "Concept plans, material direction and interior architecture are developed together as a single design story." },
  { num: "03", title: "Plan", body: "Construction documents, engineering, permits and detailed pricing are resolved before we break ground." },
  { num: "04", title: "Build", body: "The same team that designed the project manages construction — one accountable partner from start to finish." },
  { num: "05", title: "Complete", body: "A calm handover, a considered punch list and long-term aftercare for the home you'll actually live in." },
];

const IMG_PRIMARY = "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_process-design-review.webp";
const IMG_SECONDARY = "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-hallway.webp";

export default function ProcessPage() {
  return (
    <div className="min-h-screen bg-warm-bg text-ink">
      <SiteNav />
      <PageHeader
        eyebrow="Design-Build Process"
        title={<>One team, one accountable partner.</>}
        intro="From first sketch through final walkthrough, the same team leads the work. That single line of accountability is what makes the finished home feel resolved."
        crumbs={[{ label: "Home", to: "/" }, { label: "Process" }]}
      />

      {/* Primary media — full-bleed */}
      <section className="w-full">
        <img src={IMG_PRIMARY} alt="Studio table with material samples and drawings"
             className="w-screen block" style={{ aspectRatio: "16/9", objectFit: "cover" }} />
      </section>

      {/* Structured 12-col process rows */}
      <section className="w-full py-24 md:py-28">
        <div className="w-full" style={{ paddingLeft: "clamp(20px, 5vw, 96px)", paddingRight: "clamp(20px, 5vw, 96px)" }}>
          <ul>
            <li className="border-t hairline" />
            {STEPS.map(s => (
              <li key={s.num} className="border-b hairline">
                <div className="grid grid-cols-12 gap-4 md:gap-6 py-6 md:py-7 items-baseline">
                  <span className="col-span-2 eyebrow text-ink-soft">{s.num}</span>
                  <span className="col-span-10 md:col-span-4 font-serif-display font-light"
                        style={{ fontSize: "clamp(18px,1.7vw,26px)", letterSpacing: "-0.014em" }}>
                    {s.title}
                  </span>
                  <span className="col-span-12 md:col-span-6 text-ink-soft leading-[1.6]"
                        style={{ fontSize: "14px" }}>
                    {s.body}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Secondary media — full-bleed */}
      <section className="w-full pb-24 md:pb-32">
        <img src={IMG_SECONDARY} alt="Construction detail"
             className="w-screen block" style={{ aspectRatio: "16/9", objectFit: "cover" }} />
        <div className="w-full" style={{ paddingLeft: "clamp(20px, 5vw, 96px)", paddingRight: "clamp(20px, 5vw, 96px)" }}>
          <p className="mt-6 text-ink-soft leading-[1.65] max-w-[520px]" style={{ fontSize: "14px" }}>
            The same team that draws the detail also resolves it on site — closing the gap between the plan and the built room.
          </p>
        </div>
      </section>

      <StartProjectCTA />
      <SiteFooter />
    </div>
  );
}